export const actions = {
  COMBOSVG_FILTERED_LOAD_REQUESTED: 'COMBOSVG_FILTERED_LOAD_REQUESTED',
  COMBOSVG_FILTERED_LOAD_SUCCEEDED: 'COMBOSVG_FILTERED_LOAD_SUCCEEDED',
  COMBOSVG_FILTERED_LOAD_FAILED: 'COMBOSVG_FILTERED_LOAD_FAILED',

  DELETE_COMBOSVG_REQUESTED: 'DELETE_COMBOSVG_REQUESTED',
  DELETE_COMBOSVG_SUCCEEDED: 'DELETE_COMBOSVG_SUCCEEDED',
  DELETE_COMBOSVG_FAILED: 'DELETE_COMBOSVG_FAILED',

  COMBOSVG_INSERT_REQUESTED: 'COMBOSVG_INSERT_REQUESTED',
  COMBOSVG_INSERT_SUCCEEDED: 'COMBOSVG_INSERT_SUCCEEDED',
  COMBOSVG_INSERT_FAILED: 'COMBOSVG_INSERT_FAILED',

  COMBOSVG_UPDATE_REQUESTED: 'COMBOSVG_UPDATE_REQUESTED',
  COMBOSVG_UPDATE_SUCCEEDED: 'COMBOSVG_UPDATE_SUCCEEDED',
  COMBOSVG_UPDATE_FAILED: 'COMBOSVG_UPDATE_FAILED',

  COMBOSVG_BYID_LOAD_REQUESTED: 'COMBOSVG_BYID_LOAD_REQUESTED',
  COMBOSVG_BYID_LOAD_SUCCEEDED: 'COMBOSVG_BYID_LOAD_SUCCEEDED',
  COMBOSVG_BYID_LOAD_FAILED: 'COMBOSVG_BYID_LOAD_FAILED',

  COMBOSVG_BY_PRODUCTO_ID_LOAD_REQUESTED: 'COMBOSVG_BY_PRODUCTO_ID_LOAD_REQUESTED',
  COMBOSVG_BY_PRODUCTO_ID_LOAD_SUCCEEDED: 'COMBOSVG_BY_PRODUCTO_ID_LOAD_SUCCEEDED',
  COMBOSVG_BY_PRODUCTO_ID_LOAD_FILED: 'COMBOSVG_BY_PRODUCTO_ID_LOAD_FILED',

  COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_REQUESTED:
    'COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_REQUESTED',
  COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_SUCCEEDED:
    'COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_SUCCEEDED',
  COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_FILED:
    'COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_FILED',

  COMBOS_SVG_PRODUCTO_UPDATE_REQUESTED: 'COMBOS_SVG_PRODUCTO_UPDATE_REQUESTED',
  COMBOS_SVG_PRODUCTO_UPDATE_SUCCEEDED: 'COMBOS_SVG_PRODUCTO_UPDATE_SUCCEEDED',
  COMBOS_SVG_PRODUCTO_UPDATE_FAILED: 'COMBOS_SVG_PRODUCTO_UPDATE_FAILED',

  COMBOSVG_PRODUCTO_UPDATE_REQUESTED: 'COMBOSVG_PRODUCTO_UPDATE_REQUESTED',
  COMBOSVG_PRODUCTO_UPDATE_SUCCEEDED: 'COMBOSVG_PRODUCTO_UPDATE_SUCCEEDED',
  COMBOSVG_PRODUCTO_UPDATE_FAILED: 'COMBOSVG_PRODUCTO_UPDATE_FAILED',
}

export const getComboSvgFilteredAction = (dispatch, filter) => {
  dispatch({
    type: actions.COMBOSVG_FILTERED_LOAD_REQUESTED,
    payload: filter,
  })
}

export const deleteComboSvgAction = (dispatch, id) => {
  dispatch({
    type: actions.DELETE_COMBOSVG_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertComboSvgFormAction = (dispatch, formComboSvg) => {
  dispatch({
    type: actions.COMBOSVG_INSERT_REQUESTED,
    payload: formComboSvg,
  })
}

export const onSubmitUpdateComboSvgFormAction = (dispatch, formComboSvg) => {
  dispatch({
    type: actions.COMBOSVG_UPDATE_REQUESTED,
    payload: formComboSvg,
  })
}

export const getComboSvgByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.COMBOSVG_BYID_LOAD_REQUESTED,
      payload: id,
    })
  }
}

export const getCombosSvgByProductoIdAction = (dispatch, id) => {
  dispatch({
    type: actions.COMBOSVG_BY_PRODUCTO_ID_LOAD_REQUESTED,
    payload: id,
  })
}

export const updateCombosSvgProductoAction = (dispatch, payload) => {
  dispatch({
    type: actions.COMBOS_SVG_PRODUCTO_UPDATE_REQUESTED,
    payload,
  })
}

export const getComboSvgProductoByIdAction = (dispatch, payload) => {
  dispatch({
    type: actions.COMBOSVG_PRODUCTO_BY_PRODUCTO_ID_COMBOSVG_ID_LOAD_REQUESTED,
    payload,
  })
}

export const updateComboSvgProductoAction = (dispatch, payload) => {
  dispatch({
    type: actions.COMBOSVG_PRODUCTO_UPDATE_REQUESTED,
    payload,
  })
}
